/**
 * ==========================================================
 * Intimine WhatsApp Component V2
 * ==========================================================
 */
class WhatsAppComponent {
    constructor(root) {
    // Prevent duplicate initialization on the same DOM element
    if (root.__waComponent) {
        console.warn("WhatsApp component already initialized — reusing existing instance.");
        return root.__waComponent;
    }

    this.root = root;

    // Store this instance directly on the DOM element
    root.__waComponent = this;

    this.config = {
        storageKey: "intimine_whatsapp",
        endpoint: "/cart/update.js",
        successDelay: 1800,
        saveText: "Save",
        savingText: "Saving..."
    };

    this.state = {
        open: false,
        number: "",
        isSaving: false,
        useDifferentNumber: false,
        error: "",
        success: false
    };

    this.onToggle = this.toggle.bind(this);

    this.cacheDOM();
    this.bindEvents();
    this.loadState();
    this.render();
}
    cacheDOM() {
        this.toggleBtn = this.root.querySelector(".wa-toggle");
        this.content = this.root.querySelector(".wa-content");
        this.phone = this.root.querySelector(".wa-input");
        this.saveBtn = this.root.querySelector(".wa-save");
        this.edit = this.root.querySelector(".wa-edit");
        this.error = this.root.querySelector(".wa-error");
        this.success = this.root.querySelector(".wa-success");
        this.radios = this.root.querySelectorAll("input[name='wa_choice']");
        this.subtitle = this.root.querySelector(".wa-subtitle");
        this.defaultSubtitle = this.subtitle.textContent;
    }
    bindEvents() {
        this.bindAccordionEvents();
        this.bindRadioEvents();
        this.bindSaveEvents();
        this.bindEditEvents();
    }
    bindEditEvents() {
        this.edit.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.state.open = true;
            this.state.useDifferentNumber = true;
            this.render();
            if (this.phone) {
                this.phone.value = this.state.number;
            }
            this.phone?.focus();
        });
    }
    bindAccordionEvents() {

    this.toggleBtn.addEventListener("click", this.onToggle);
}
    bindRadioEvents() {
        this.radios.forEach(radio => {
            radio.addEventListener("change", () => {
                this.setPhoneMode(radio.value);
            });
        });
    }
    bindSaveEvents() {
        this.saveBtn.addEventListener("click", () => {
            this.save();
        });
    }
    loadState() {
        const number = localStorage.getItem(this.config.storageKey);
        if (!number) return;
        this.state.number = number;
    }    
    open() {
        this.state.open = true;
        this.render();
        requestAnimationFrame(() => {
            this.content.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        });
    }
    
toggle() {
    if (this.state.open) {
        this.close();
    } else {
        this.open();
    }
}
    setPhoneMode(mode) {
        this.state.useDifferentNumber = mode === "different";
        this.render();
    }
    syncRadios() {
        this.radios.forEach(radio => {
            radio.checked = this.state.useDifferentNumber ? radio.value === "different" : radio.value === "same";
        });
    }
    normalizeNumber(number) {
        number = number.replace(/\D/g, "");
        if (number.startsWith("92")) {
            number = "0" + number.substring(2);
        }
        return number;
    }
    validate(number) {
        return /^03\d{9}$/.test(number);
    }
    setLoading(state) {
        this.state.isSaving = state;
        this.render();
    }
    async updateCart(number) {
        const response = await fetch(this.config.endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                attributes: {
                    whatsapp_number: number
                }
            })
        });
        if (!response.ok) {
            throw new Error("Unable to save WhatsApp number.");
        }
        return response.json();
    }
    saveLocal(number) {
        localStorage.setItem(this.config.storageKey, number);
        this.state.number = number;
    }
    close() {
        this.state.open = false;
        this.render();
    }
    showSuccess() {
        this.state.error = "";
        this.state.success = true;
        this.render();
        clearTimeout(this.successTimer);
        this.successTimer = setTimeout(() => {
            this.state.success = false;
            this.render();
        }, this.config.successDelay);
    }
    showError(message) {
        this.state.error = message;
        this.render();
    }
    clearError() {
        this.state.error = "";
    }
    async save() {
        if (this.state.isSaving) return;
        this.state.success = false;
        this.clearError();
        this.render();
        let number = this.normalizeNumber(this.phone.value.trim());
        if (this.phone.value !== number) {
            this.phone.value = number;
        }
        if (!this.validate(number)) {
            this.showError("Please enter a valid Pakistani mobile number.");
            this.phone?.focus();
            return;
        }
        this.setLoading(true);
        try {
            await this.updateCart(number);
            this.saveLocal(number);
            this.state.useDifferentNumber = false;
            this.close();
            this.showSuccess();
        } catch (error) {
            console.error("WhatsApp Component:", error);
            this.showError("Unable to save WhatsApp number.");
        } finally {
            this.setLoading(false);
        }
    }
    render() {
        this.root.classList.toggle("is-open", this.state.open);
        this.root.classList.toggle("is-different", this.state.useDifferentNumber);
        this.syncRadios();
        this.root.classList.toggle("is-saved", Boolean(this.state.number));
        if (this.edit) {
    this.edit.hidden = !this.state.number || this.state.open;
}
        this.toggleBtn.setAttribute("aria-expanded", this.state.open);
        this.content.setAttribute("aria-hidden",
            (!this.state.open).toString());
        const subtitle = this.state.number || this.defaultSubtitle;
        if (this.subtitle.textContent !== subtitle) {
            this.subtitle.textContent = subtitle;
        }
        if (this.phone && !this.state.useDifferentNumber && this.phone.value !== this.state.number) {
            this.phone.value = this.state.number;
        }
        this.saveBtn.disabled = this.state.isSaving;
        this.saveBtn.textContent = this.state.isSaving ? this.config.savingText : this.config.saveText;
        this.error.classList.toggle("is-visible", Boolean(this.state.error));
this.error.textContent = this.state.error;
        this.success.hidden = !this.state.success;
        if (this.state.success) {
            this.error.hidden = true;
        }
    }
}

function initWhatsAppComponents(scope = document) {
    scope.querySelectorAll('[data-wa]').forEach((root) => {

        // Already initialized on this exact DOM element
        if (root.__waComponent) {
            return;
        }

        // Safety guard
        if (root.dataset.initialized === "true") {
            return;
        }

        root.dataset.initialized = "true";

        new WhatsAppComponent(root);
    });
}


/**
 * Initial page load
 */
document.addEventListener("DOMContentLoaded", () => {
    initWhatsAppComponents();
});


/**
 * Shopify cart drawer is dynamic.
 * Re-initialize WhatsApp when Shopify replaces
 * the cart drawer DOM.
 */
const waCartObserver = new MutationObserver((mutations) => {

    let shouldInitialize = false;

    for (const mutation of mutations) {

        if (mutation.type !== "childList") {
            continue;
        }

        if (mutation.addedNodes.length > 0) {
            shouldInitialize = true;
            break;
        }
    }

    if (!shouldInitialize) {
        return;
    }

    initWhatsAppComponents(document);
});


/**
 * Observe the cart drawer itself.
 */
function startWhatsAppCartObserver() {

    const cartDrawer = document.querySelector("#CartDrawer");

    if (!cartDrawer) {
        return;
    }

    waCartObserver.observe(cartDrawer, {
        childList: true,
        subtree: true
    });

}


if (document.readyState === "loading") {

    document.addEventListener("DOMContentLoaded", () => {
        startWhatsAppCartObserver();
    });

} else {

    startWhatsAppCartObserver();

}